import { render, staticRenderFns } from "./WalletReversal.vue?vue&type=template&id=22cf85e8&"
import script from "./WalletReversal.vue?vue&type=script&lang=js&"
export * from "./WalletReversal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports